import Link from "next/link";
import { PropTypes } from "prop-types";
import Styles from "./breadcumbs.module.css";

function Breadcrumbs({ breadcrumbs = [], isCategoryPage }) {
  return (
    <div className={`text-sm ${Styles.breadcrumbs} breadcrumbs mb-[1.25rem]`}>
      <ul>
        <li className="text-[#E81E61]">
          <Link href="/">Home</Link>
        </li>
        {breadcrumbs.length > 1 && (
          <>
            {breadcrumbs
              ?.slice(0, breadcrumbs.length - 1)
              ?.map((breadcrumb) => (
                <li key={breadcrumb.value} className="text-[#E81E61]">
                  {isCategoryPage ? (
                    <Link href={`/category/${breadcrumb.link}`}>
                      {breadcrumb.value}
                    </Link>
                  ) : (
                    <Link href={`/${breadcrumb.link}`}>{breadcrumb.value}</Link>
                  )}
                </li>
              ))}
          </>
        )}
        <li className="text-[#0A101A]">
          {breadcrumbs.length > 1 &&
          breadcrumbs[breadcrumbs.length - 1].value?.length > 20
            ? `${breadcrumbs[breadcrumbs.length - 1].value.slice(0, 20)}...`
            : breadcrumbs[breadcrumbs.length - 1]?.value}
        </li>
      </ul>
    </div>
  );
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default Breadcrumbs;
